import {
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from "@mui/material";
import { DatePickerField } from "components/core";
import { useBranchCurrentDate } from "hooks";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { getAuditSampleMethod } from "services/api/query";
import { ERROR_TYPES } from "utils/constants";
import {
  getOptions,
  status2
} from "utils/constants/open-media-processing/OpenMediaAuditConstants";
import {
  dataDogErrorLog,
  findErrorMessage,
  getDateFromUTCFormat,
  handleRefId
} from "utils/helpers";
import { OpenMediaAuditStyles } from "./OpenMediaAuditDetailStyles";

const ShowFormattedDate = ({ value }) => {
  let formattedDate = "";
  if (value) {
    formattedDate = getDateFromUTCFormat(value, {
      withTime: true
    });
  }
  return <Typography>{formattedDate}</Typography>;
};

const Distribution = ({
  setIsLoading,
  setThrowError,
  setThrowErrorMessage,
  auditDetailForm,
  isViewMode: isNewAudit,
  viewData,
  allAuditData,
  directionData
}) => {
  const currentDate = useBranchCurrentDate();
  const [sampleMethodList, setSampleMethodList] = useState([]);
  const [viewDataList, setViewDataList] = useState([]);
  const { values, setFieldValue } = auditDetailForm;
  useEffect(() => {
    if (allAuditData && allAuditData[3]?.length) {
      const arr = allAuditData[3].sort(
        (a, b) =>
          new Date(a.completed_datetime) - new Date(b.completed_datetime)
      );
      setViewDataList([...arr]);
    }
  }, [allAuditData]);

  useEffect(() => {
    if (isNewAudit) {
      setFieldValue("due_date", currentDate);
    }
    handleGetSmpleData();
    //eslint-disable-next-line
  }, []);
  const handleGetSmpleData = async () => {
    setIsLoading(true);
    try {
      const dataSets = await getAuditSampleMethod();
      const list = getOptions(dataSets, "descr", "id");
      setSampleMethodList(list);
      setFieldValue("audit_sample_method_id", list[0]?.label);
    } catch (error) {
      const { refId, message } = handleRefId(
        findErrorMessage(ERROR_TYPES.ISSUE)
      );
      dataDogErrorLog(message, "", { error: error }, refId);
      setThrowErrorMessage(message);
      setThrowError(true);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <Grid item xs={4} sm={6} md={4} lg={3}>
        <FormControl fullWidth>
          <DatePickerField
            id="due-date"
            name="dueDate"
            label={t("openMediaAuditDetail.dueDate")}
            value={values?.due_date}
            onChange={(value) => {}}
            disabled={true}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6} sm={12} md={6} lg={5}>
        <FormControl fullWidth>
          <TextField
            labelId="comments"
            label={t("openMediaAuditDetail.comments")}
            value={values?.comment}
            onChange={(event) => {
              setFieldValue("comment", event.target.value);
            }}
            fullWidth
            multiline
            rows={4}
            name="review-comments"
            id="review-comments"
            disabled={status2?.includes(viewData?.audit_status)}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6} sm={12} md={6} lg={5}>
        <Typography style={OpenMediaAuditStyles.commentSectionText}>
          {t("openMediaAuditDetail.pastComments")}
        </Typography>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={OpenMediaAuditStyles.commentSection}
        >
          {allAuditData[1]?.length
            ? allAuditData[1]?.map((item) => {
                return (
                  <Typography marginBottom={2} key={item?.employee_name}>
                    {getDateFromUTCFormat(item?.comment_date_ltz, {
                      withTime: true
                    })}{" "}
                    {item?.employee_name}-{item?.comment}
                  </Typography>
                );
              })
            : ""}
        </Grid>
      </Grid>

      <Grid container spacing={2} lg={12} margin={0}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          marginTop={2}
          marginBottom={2}
        >
          <Divider />
        </Grid>
        <Grid item xs={4} sm={6} md={4} lg={3}>
          <>
            {isNewAudit ? (
              <>
                <FormControl fullWidth>
                  <InputLabel id="sample-method">
                    {t("openMediaAuditDetail.sampleMethod")}
                  </InputLabel>
                  <Select
                    labelId="sample-method"
                    id="sample-method-id"
                    name="sampleMethod"
                    value={values?.audit_sample_method_id}
                    label={t("openMediaAuditDetail.sampleMethod")}
                    onChange={(e) => {
                      setFieldValue("audit_sample_method_id", e.target.value);
                    }}
                  >
                    {sampleMethodList?.map((item) => {
                      return (
                        <MenuItem value={item.label} key={item.label}>
                          {item.value}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </>
            ) : (
              <>
                {t("openMediaAuditDetail.sampleMethod")}
                <Typography>{viewData?.audit_sample_method_descr} </Typography>
              </>
            )}
          </>
        </Grid>

        <Grid item xs={4} sm={6} md={4} lg={3}>
          <Typography variant="caption">
            {t("openMediaAuditDetail.batchCount")}{" "}
          </Typography>
          <Typography>
            {viewDataList?.length || directionData?.media_count}{" "}
          </Typography>
        </Grid>
        {!isNewAudit ? (
          <>
            <Grid item xs={4} sm={6} md={4} lg={3}>
              <Typography variant="caption">
                {t("openMediaAuditDetail.batchFrom")}{" "}
              </Typography>
              <ShowFormattedDate value={viewDataList[0]?.completed_datetime} />
            </Grid>
            <Grid item xs={4} sm={6} md={4} lg={3}>
              <Typography variant="caption">
                {t("openMediaAuditDetail.batchTo")}{" "}
              </Typography>
              <ShowFormattedDate
                value={
                  viewDataList[viewDataList?.length - 1]?.completed_datetime
                }
              />
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={4} sm={6} md={4} lg={3}>
              <Typography variant="caption">
                {t("openMediaAuditDetail.oldestBatch")}
              </Typography>
              <ShowFormattedDate value={directionData?.oldest_batch_datetime} />
            </Grid>
            <Grid item xs={4} sm={6} md={4} lg={3}>
              <Typography variant="caption">
                {t("openMediaAuditDetail.distributionTasks")}
              </Typography>
              <Typography>-</Typography>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default Distribution;
